import classNames from 'classnames';
import NextLink from 'components/CustomRoutingLink';
import {Typography} from 'components/Typography';
import {BusinessPopup} from './BusinessPopup';
import {LocationItem} from 'modules/locations/components/LocationItem';
import style from '../style.module.scss';
import {NEXT_PUBLIC_MASTER_HOST} from 'core/helpers/env';
import {ExpressOrderPopup} from 'modules/express-order/components/ExpressOrderPopup';
import Icon from 'components/Icon';
import {useGetAbExpressOrder} from 'modules/ab-tests/hooks';
import {usePriveLinkClickGtag} from 'hooks/analytics/gtag/usePriveLinkClickGtag';
import {FC, useMemo} from 'react';

interface IHeaderTopProps {
    isHeaderTopHidden: boolean;
    addressListUrl: () => string;
}

export const HeaderTop: FC<IHeaderTopProps> = ({isHeaderTopHidden, addressListUrl}) => {
    const {isActive: isAbExpressOrder} = useGetAbExpressOrder();

    const priveLinkClickGtag = usePriveLinkClickGtag();

    const wineryLink = useMemo(() => addressListUrl(), [addressListUrl]);

    return (
        <div className={style.headerTop}>
            <ul className={style.headerTopLeftSide}>
                {/* <NextLink href={`${NEXT_PUBLIC_MASTER_HOST}/prive/`} legacyBehavior passHref>*/}
                <a
                    className={classNames(style.headerTopItem, 'private-navigation__link')}
                    data-autotest-target={'header-links'}
                    data-autotest-target-id={'header-links-prive'}
                    onClick={priveLinkClickGtag}
                    href={`${NEXT_PUBLIC_MASTER_HOST}/prive/`}
                >
                    <Typography className={style.headerDropDown} element={'div'} variant={'label-14-r'}>
                        Сервис SimplePrivé
                    </Typography>
                </a>
                {/* </NextLink>*/}
                <BusinessPopup />
            </ul>
            <ul className={style.headerTopRightSide}>
                {isAbExpressOrder && (
                    <li
                        className={classNames(style.headerDropDown, style.headerLocation, {
                            [style.hidden]: isHeaderTopHidden,
                        })}
                    >
                        <ExpressOrderPopup resolution={'DESKTOP'} />
                    </li>
                )}
                <li
                    className={classNames(style.headerDropDown, style.headerLocation, {
                        [style.hidden]: isHeaderTopHidden,
                    })}
                >
                    <LocationItem
                        cityItemTargetPostfix={'dropdown-city'}
                        dataAutotestTarget={'header-location'}
                        isHeaderTopHidden={isHeaderTopHidden}
                        testClassName={'location_current dropdown_toggler'}
                        textVariant={{MB: 'label-14-r', TB: 'label-14-r', DT: 'label-14-r'}}
                    />
                </li>
                {!isAbExpressOrder && (
                    <li>
                        <NextLink
                            className={classNames(style.headerTopItem, 'header-wineries')}
                            data-autotest-target={'header-location'}
                            data-autotest-target-id={'header-location-wineries'}
                            href={wineryLink}
                        >
                            <Typography className={style.headerDropDown} element={'div'} variant={'label-14-r'}>
                                <Icon className={style.locationIcon} icon={'location-placemark'} />
                                Адреса винотек
                            </Typography>
                        </NextLink>
                    </li>
                )}
            </ul>
        </div>
    );
};
